import type { MailEntrypoint } from "owa-m365-acquisitions/lib/types";
import type { AppButtonOnExecuteParameter } from "owa-acui";
import type { MailboxInfo } from "owa-client-types";
import { lazyRibbonPinnedMessageExtensionOnExecute } from "owa-message-extension-flyout";
import { getSelectedTableView } from "owa-mail-list-store";
import { getSingleSelectedItemFromView } from "./getSelectedItemFromView";

export function onPinnedMessageExtensionExecute(appId: string, targetWindow: Window, entrypoint: MailEntrypoint, params: AppButtonOnExecuteParameter, itemId?: string, composeId?: string, mailboxInfo?: MailboxInfo): void {
    if (entrypoint === "MessageRead" && !itemId) {
        itemId = getSingleSelectedItemFromView(getSelectedTableView())?.ItemId?.Id;
    }
    
    lazyRibbonPinnedMessageExtensionOnExecute.importAndExecute(appId, targetWindow, entrypoint, params, itemId, composeId, mailboxInfo);
}
